import React, { useCallback, useEffect, useRef, useState } from 'react';
import { QRCode, Space, Typography } from 'antd';
import QrAPI from '../api/qr';

const { Text, Title } = Typography;

const TTL = 20;          // must match QR_TTL_SECONDS on the backend
const REFRESH_AT = 15;   // refresh 5s before token expires

export default function MyQR() {
  const [qrText, setQrText] = useState('');
  const [status, setStatus] = useState('loading');
  const [countdown, setCountdown] = useState(TTL);
  const refreshTimer = useRef(null);
  const countdownTimer = useRef(null);

  const resetCountdown = () => {
    setCountdown(TTL);
  };

  const refresh = useCallback(() => {
    setStatus('loading');
    QrAPI.myQR(
      (res) => {
        setQrText(res.qr_text);
        setStatus('active');
        resetCountdown();
      },
      () => {
        setStatus('expired');
      },
    );
  }, []);

  useEffect(() => {
    refresh();
    refreshTimer.current = setInterval(refresh, REFRESH_AT * 1000);
    countdownTimer.current = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => {
      clearInterval(refreshTimer.current);
      clearInterval(countdownTimer.current);
    };
  }, [refresh]);

  return (
    <Space direction="vertical" align="center" style={{ width: '100%', paddingTop: 16 }}>
      <Title level={4} style={{ margin: 0 }}>My QR</Title>
      <Text type="secondary">Show this QR to log in to a ChulaSSO-connected app</Text>
      <QRCode
        value={qrText || ' '}
        status={status}
        size={240}
        icon="/html/logo-chula-color.svg"
        iconSize={48}
        onRefresh={refresh}
      />
      {status === 'active' && (
        <Text type="secondary">Refreshes in {countdown}s</Text>
      )}
    </Space>
  );
}
